import Index from './Index'
import Xero from './Xero'
import PHPStatus from './PHPStatus'
import ProjectAgreements from './ProjectAgreements'
import ProjectAgreement from './ProjectAgreement'
import SignRequestTemplates from './SignRequestTemplates'
import SignRequestTemplate from './SignRequestTemplate'
import StageLeadTimes from './StageLeadTimes'
import AIHistory from './AIHistory'
import AIHistoryConversation from './AIHistoryConversation'

export default {
    Index,
    Xero,
    PHPStatus,
    ProjectAgreements,
    ProjectAgreement,
    SignRequestTemplates,
    SignRequestTemplate,
    StageLeadTimes,
    AIHistory,
    AIHistoryConversation
}
